export const sortTypes = Object.freeze({
  TIME: 'time',
  UPDATED_AT: 'updatedAt',
  DELETED_AT: 'deletedAt',
  TITLE: 'title',
});
